import { wxShare } from '@/libs/wxjssdk'
import { getProductDetails } from '@/api/product'
export default {
    data () {
        return {
            cdnUrl: this.$config.baseUrl.cdnUrl,
            isShowNav: false,
            showVideo: false,
            videoUrl: '',
            detailsObj: {}, // 后台返回的所有数据
            productDetails: [], // 产品详情
            productMaterial: { // 绑定的产品视频
                video: [],
                pdf: []
            }, // 产品资料
            productVideo: { // 绑定的操作视频
                video: [],
                pdf: []
            },
            productParams: [], // 产品参数
            introLength: 0,
            jianjie: ''
        }
    },
    computed: {},
    created () {

    },
    methods: {
        sharePage () {
            const params = {
                title: `${this.detailsObj.title}`, // 分享标题
                desc: `${this.detailsObj.jianjie}`, // 分享描述
                // link: `${window.location.href}&isShowNav=true`, // 分享链接
                link: `${window.location.href.split('#')[0]}#/productStore?detail_id=${this.id}`, // 分享链接
                imgUrl: `${this.cdnUrl}${this.detailsObj.cover_img}` // 分享图标
            }
            wxShare(params)
        },
        // 子组件单击了视频列表
        videoChange (item) {
            var videoUrl = JSON.parse(item.video_url)
            this.videoUrl = videoUrl[0]
            this.dplayerOption(`${this.cdnUrl + this.videoUrl}`)
            this.showVideo = true
        },
        /** 网络请求 **/
        // 根据id获取产品详情
        getProductDetailsPort () {
            var params = {
                id: this.id
            }
            getProductDetails(params).then(res => {
                if (res.errCode === 0) {
                    this.$toast.clear()
                    var data = res.data
                    this.detailsObj = data
                    console.log('打印数据++ccc', res)
                    document.title = data.title || '产品详情'
                    this.sharePage()
                    this.productDetails = JSON.parse(data.desc || '[]')
                    this.productMaterial.video = data.video || []
                    this.productMaterial.pdf = data.pdf || []
                    this.productVideo.video = data.video2 || []
                    // this.productVideo.pdf = data.pdf || []
                    this.productParams = JSON.parse(data.technology || '[]')
                    this.sliderList = JSON.parse(data.img_url || '[]')
                    var jianjieStr = JSON.stringify(data.jianjie).replace(/\\n|\\n\\n/g, '<br/>')
                    this.jianjie = JSON.parse(jianjieStr)
                    this.introLength = data.jianjie.length
                    this.solutionList = data.solution // 关联的解决方案
                }
                var query = this.$route.query
                this.$nextTick(function () {
                    this.tabsActive = query.tabShow
                });
                
            }).catch(err => {
                console.log('获取产品详情接口报错', err)
            })
        }
    }
}
